import "../../index.css";

const Divider = ({ children }) => {
    return (
        <div className="divider-container">
            <div className="divider-line" />
            {
                children &&
                <span className="divider-content">{children}</span>
            }
            <div className="divider-line" />
        </div>
    );
};

export default Divider;